/**
 * Created by hashinig on 1/28/19.
 */
(function () {
  'use strict';

  angular
    .module('crewSignInScreen')
    .service('crewSignInScreenService', crewSignInScreenService);

  function crewSignInScreenService(RemoteService) {
    var vm = this;

    vm.getCrewSignInScreenData = function(successFn, errorFn){
      RemoteService.searchCrewSignInScreenData().then(
        function (response) {
          if(response.success){
            successFn(response.crewSignInReportDTOMap);
          }
        },
        function (error) {
          errorFn(error);
        }
      );
    };


  }
}());
